module.exports = __webpack_public_path__ + "static/assets/img/remote_events_2.ce769d1b.svg";